export default __webpack_public_path__ + "static/bm-ddc9218e187f11a06d5306874690e31b.svg";